module.exports = __webpack_public_path__ + "img/Philcare-Member.7780e38c.png";